import { round } from 'lodash';
import * as getters from '../store/getters';
import FormatMixin from '../../../../Application/mixins/FormatMixin';

const { valorReal } = FormatMixin.methods;

const taxInformationForEdit = (taxInformation) => {
  const { entryDate, issueDate, nfe, ...rest } = taxInformation;

  return {
    ...rest,
    ...nfe,
    natureza: {
      ...getters.getDefaultNaturezaState(),
      ...rest.natureza,
    },
    entryDate: new Date(entryDate),
    issueDate: new Date(issueDate),
  };
};

const LinkedDocumentsForEdit = (linkedDocuments) => {
  if (!linkedDocuments) return null;

  const { linkedDocumentCollection } = linkedDocuments;
  const updatedLinkedDocuments = linkedDocumentCollection.map((obj) => {
    const updatedObj = obj;
    updatedObj.edited = true;
    return updatedObj;
  });

  return {
    ...linkedDocuments,
    linkedDocumentCollection: [...updatedLinkedDocuments],
  };
};

const productsForEdit = (products) => {
  const { productOfPurchaseCollection } = products;
  const updatedProducts = productOfPurchaseCollection.map((obj) => {
    const updatedObj = obj;
    updatedObj.edited = true;
    return updatedObj;
  });

  return {
    ...products,
    productOfPurchaseCollection: [...updatedProducts],
  };
};

const transportForEdit = (transport) => {
  if (!transport) return null;

  const weightDecimalConfiguration = 3;
  return {
    ...transport,
    freight: {
      id: Number(transport.freight),
    },
    vehicle: {
      placa: transport.vehicle.identification,
    },
    volume: {
      ...transport?.volume,
      grossWeight:
        valorReal(
          round(
            transport?.volume?.grossWeight,
            weightDecimalConfiguration,
          ),
          weightDecimalConfiguration,
        ),
      netWeight:
        valorReal(
          round(
            transport?.volume?.netWeight,
            weightDecimalConfiguration,
          ),
          weightDecimalConfiguration,
        ),
    },
  };
};

export const stdObjectForEdit = async (purchase) => ({
  ...purchase,
  id: purchase.id,
  isEditing: true,
  taxInformation: taxInformationForEdit(purchase.taxInformation),
  linkedDocuments: LinkedDocumentsForEdit(purchase.linkedDocuments),
  supplierInformation: {
    supplier: purchase.supplier,
  },
  products: productsForEdit(purchase.products),
  transport: transportForEdit(purchase.transport),
});
